module.exports = __webpack_public_path__ + "img/hrm-jordan.d8a1ddb.png";